/* ==========================================================================
   Comfort Pro 360 — interacciones propias (sin librerías externas)
   ========================================================================== */

(function () {
  "use strict";

  /* Cada sección incluye este archivo, así que el navegador lo ejecuta una vez
     por sección. Este guardia hace que solo cuente la primera. */
  if (window.__mtScriptsCargado) return;
  window.__mtScriptsCargado = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Marca un elemento como ya preparado. Devuelve false si ya lo estaba, para
     que ninguna función vuelva a engancharle listeners (p. ej. al recargar una
     sección desde el editor de Shopify). */
  function nuevo(el) {
    if (!el || el.dataset.mtListo === "1") return false;
    el.dataset.mtListo = "1";
    return true;
  }

  /* --------------------------------------- abrir el formulario de Releasit */
  /* La tienda vende con pago contra entrega mediante el formulario de Releasit.
     Ese formulario se abre con el botón de compra de la app (#rsi_buy_now_button).
     Reutilizamos EXACTAMENTE ese mismo mecanismo: cualquier elemento con el
     atributo [data-mt-releasit] hace clic en ese botón y abre el formulario.
     Como este archivo se ejecuta una sola vez (guardia de arriba), el listener
     se engancha una única vez con delegación de eventos. */
  document.addEventListener("click", function (ev) {
    var disparador = ev.target.closest("[data-mt-releasit]");
    if (!disparador) return;
    ev.preventDefault();
    /* El botón de Releasit que SÍ lleva el producto es el que vive dentro del
       formulario de producto (.shopify-product-form). Ojo: hay varios
       #rsi_buy_now_button en la página y el primero NO lleva producto (abre el
       formulario vacío), por eso hay que buscar específicamente el del formulario. */
    var boton =
      document.querySelector(".shopify-product-form #rsi_buy_now_button") ||
      document.querySelector("form[action*='/cart/add'] #rsi_buy_now_button");
    if (boton) {
      boton.click();
      return;
    }
    /* En páginas sin producto (la portada) no hay formulario de producto, así que
       Releasit no puede saber qué producto es. Llevamos al cliente a la página del
       producto, donde el formulario carga el producto correctamente. */
    window.location.href = "/products/masajeador-de-mano";
  });

  /* ---------------------------------------------------------------- reveals */
  /* Por debajo de 990px no se anima nada al hacer scroll: el texto sale de
     una vez. Si no, parece que la página no ha terminado de cargar. */
  var movil = window.matchMedia("(max-width: 989px)").matches;

  function initReveal() {
    var elems = document.querySelectorAll(".mt-reveal");
    if (!elems.length) return;

    if (movil || reduce || !("IntersectionObserver" in window)) {
      elems.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("mt-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    elems.forEach(function (el) { obs.observe(el); });
  }

  /* ------------------------------------------------------- entrada del hero */
  function initHero() {
    var hero = document.querySelector(".mt-hero");
    if (!hero) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add("mt-visible"); });
    });
  }

  /* --------------------------------------------------- parallax suave hero */
  function initParallax() {
    if (reduce) return;
    var capas = document.querySelectorAll("[data-mt-parallax]");
    if (!capas.length) return;
    if (window.matchMedia("(max-width: 989px)").matches) return;

    var pendiente = false;
    function pintar() {
      pendiente = false;
      var y = window.pageYOffset;
      capas.forEach(function (capa) {
        var f = parseFloat(capa.getAttribute("data-mt-parallax")) || 0.12;
        var caja = capa.parentElement.getBoundingClientRect();
        if (caja.bottom < -200 || caja.top > window.innerHeight + 200) return;
        capa.style.transform = "translate3d(0," + (y - (caja.top + y)) * f + "px,0)";
      });
    }
    window.addEventListener(
      "scroll",
      function () {
        if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
      },
      { passive: true }
    );
    pintar();
  }

  /* ------------------------------------------------------- cifras animadas */
  function initContadores() {
    var nums = document.querySelectorAll("[data-mt-contador]");
    if (!nums.length) return;

    function animar(el) {
      var destino = parseFloat(el.getAttribute("data-mt-contador"));
      var dec = (el.getAttribute("data-mt-decimales") || "0") | 0;
      if (reduce || isNaN(destino)) { el.textContent = destino.toFixed(dec); return; }
      var ini = null;
      var dur = 1500;
      function paso(t) {
        if (ini === null) ini = t;
        var p = Math.min((t - ini) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (destino * e).toFixed(dec);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    // Sin animaciones (o sin observador): enseña el número final ya
    if (reduce || !("IntersectionObserver" in window)) { nums.forEach(animar); return; }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animar(e.target); obs.unobserve(e.target); }
        });
      },
      { threshold: 0.5 }
    );
    nums.forEach(function (n) { if (nuevo(n)) obs.observe(n); });
  }

  /* ------------------------------------------- cronómetro del calor (8→10s) */
  function initCalor() {
    var zona = document.querySelector("[data-mt-calor]");
    if (!zona || !nuevo(zona)) return;
    var num = zona.querySelector(".mt-calor__crono-num");
    var barra = zona.querySelector(".mt-calor__barra span");
    if (!num) return;

    var tope = parseFloat(zona.getAttribute("data-mt-calor")) || 10;

    function correr() {
      if (reduce) {
        num.textContent = tope;
        if (barra) barra.style.width = "100%";
        return;
      }
      var ini = null;
      var dur = 2200;
      function paso(t) {
        if (ini === null) ini = t;
        var p = Math.min((t - ini) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        num.textContent = Math.round(tope * e);
        if (barra) barra.style.width = (e * 100).toFixed(1) + "%";
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (reduce || !("IntersectionObserver" in window)) { correr(); return; }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { correr(); obs.unobserve(e.target); }
        });
      },
      { threshold: 0.45 }
    );
    obs.observe(zona);
  }

  /* --------------------------------------------------- pestañas de modos */
  function initModos() {
    document.querySelectorAll("[data-mt-tabs]").forEach(function (zona) {
      if (!nuevo(zona)) return;
      var tabs = zona.querySelectorAll(".mt-tab");
      var paneles = zona.querySelectorAll(".mt-panel");
      var visual = zona.querySelector(".mt-modos__pulso");
      if (!tabs.length) return;

      function activar(i) {
        tabs.forEach(function (t, n) { t.setAttribute("aria-selected", n === i ? "true" : "false"); });
        paneles.forEach(function (p, n) { p.setAttribute("data-activo", n === i ? "true" : "false"); });
        if (visual) {
          var vel = tabs[i].getAttribute("data-mt-vel") || "3.4";
          visual.style.setProperty("--mt-modo-vel", vel + "s");
        }
        var escala = paneles[i] && paneles[i].querySelector(".mt-escala");
        if (escala) {
          var n = parseInt(tabs[i].getAttribute("data-mt-nivel") || "3", 10);
          escala.querySelectorAll("i").forEach(function (b, k) {
            b.classList.toggle("mt-on", k < n);
          });
        }
      }

      tabs.forEach(function (t, i) {
        t.addEventListener("click", function () { activar(i); });
        t.addEventListener("keydown", function (ev) {
          if (ev.key === "ArrowRight" || ev.key === "ArrowLeft") {
            ev.preventDefault();
            var sig = (i + (ev.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length;
            tabs[sig].focus();
            activar(sig);
          }
        });
      });

      activar(0);
    });
  }

  /* ------------------------------------------------- carrusel de reseñas */
  function initCarrusel() {
    document.querySelectorAll("[data-mt-carrusel]").forEach(function (zona) {
      if (!nuevo(zona)) return;
      var pista = zona.querySelector(".mt-resenas__pista");
      if (!pista) return;
      var prev = zona.querySelector("[data-mt-prev]");
      var sig = zona.querySelector("[data-mt-sig]");

      function salto() {
        var card = pista.querySelector(".mt-resena");
        if (!card) return 320;
        return card.getBoundingClientRect().width + 20;
      }

      function estado() {
        if (!prev || !sig) return;
        prev.disabled = pista.scrollLeft <= 4;
        sig.disabled = pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 4;
      }

      if (prev) prev.addEventListener("click", function () { pista.scrollBy({ left: -salto(), behavior: "smooth" }); });
      if (sig) sig.addEventListener("click", function () { pista.scrollBy({ left: salto(), behavior: "smooth" }); });
      pista.addEventListener("scroll", estado, { passive: true });
      window.addEventListener("resize", estado);
      estado();

      /* arrastre con ratón */
      var abajo = false, inicioX = 0, inicioScroll = 0, movido = false;

      pista.addEventListener("mousedown", function (e) {
        abajo = true; movido = false;
        inicioX = e.pageX;
        inicioScroll = pista.scrollLeft;
        pista.classList.add("mt-arrastrando");
      });
      window.addEventListener("mouseup", function () {
        if (!abajo) return;
        abajo = false;
        pista.classList.remove("mt-arrastrando");
      });
      window.addEventListener("mousemove", function (e) {
        if (!abajo) return;
        var d = e.pageX - inicioX;
        if (Math.abs(d) > 4) movido = true;
        pista.scrollLeft = inicioScroll - d;
      });
      pista.addEventListener("click", function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* -------------------------------------------------------------- acordeón */
  function initFaq() {
    document.querySelectorAll("[data-mt-faq]").forEach(function (zona) {
      var items = zona.querySelectorAll(".mt-faq__item");

      function pintar(item, abrir) {
        var resp = item.querySelector(".mt-faq__respuesta");
        var boton = item.querySelector(".mt-faq__boton");
        if (!resp) return;
        var interior = resp.firstElementChild;
        item.setAttribute("data-abierto", abrir ? "true" : "false");
        if (boton) boton.setAttribute("aria-expanded", abrir ? "true" : "false");
        resp.style.height = abrir && interior ? interior.offsetHeight + "px" : "0px";
      }

      items.forEach(function (item) {
        if (!nuevo(item)) return;
        var boton = item.querySelector(".mt-faq__boton");
        if (!boton) return;

        // Estado inicial (respeta la pregunta marcada como "empezar abierta")
        pintar(item, item.getAttribute("data-abierto") === "true");

        boton.addEventListener("click", function () {
          var abierto = item.getAttribute("data-abierto") === "true";
          if (!abierto && zona.getAttribute("data-mt-faq") === "solo-uno") {
            items.forEach(function (o) { if (o !== item) pintar(o, false); });
          }
          pintar(item, !abierto);
        });
      });

      // Al cambiar el ancho, recalcula la altura de las abiertas
      window.addEventListener("resize", function () {
        items.forEach(function (item) {
          if (item.getAttribute("data-abierto") === "true") pintar(item, true);
        });
      });
    });
  }

  /* ------------------------------------------------ galería de producto */
  function initGaleria() {
    var gal = document.querySelector("[data-mt-galeria]");
    if (!gal) return;
    var principal = gal.querySelector("[data-mt-principal]");
    var minis = gal.querySelectorAll(".mt-mini");
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      if (!nuevo(mini)) return;
      mini.addEventListener("click", function () {
        var src = mini.getAttribute("data-mt-src");
        var alt = mini.getAttribute("data-mt-alt") || "";
        if (!src) return;
        principal.style.opacity = "0";
        setTimeout(function () {
          principal.src = src;
          principal.alt = alt;
          principal.style.opacity = "1";
        }, 180);
        minis.forEach(function (m) { m.setAttribute("aria-current", m === mini ? "true" : "false"); });
      });
    });
  }

  /* ------------------------------------------------------------ cantidad */
  function initCantidad() {
    document.querySelectorAll("[data-mt-cantidad]").forEach(function (zona) {
      if (!nuevo(zona)) return;
      var input = zona.querySelector("input");
      var menos = zona.querySelector("[data-mt-menos]");
      var mas = zona.querySelector("[data-mt-mas]");
      if (!input) return;
      function set(v) {
        var n = Math.max(1, Math.min(99, v));
        input.value = n;
      }
      if (menos) menos.addEventListener("click", function () { set((parseInt(input.value, 10) || 1) - 1); });
      if (mas) mas.addEventListener("click", function () { set((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener("change", function () { set(parseInt(input.value, 10) || 1); });
    });
  }

  /* ------------------------------------------------------------ variantes */
  function initVariantes() {
    var zona = document.querySelector("[data-mt-variantes]");
    if (!zona) return;
    var datos = document.getElementById("mt-datos-variantes");
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var inputId = zona.querySelector("[data-mt-variante-id]");
    var precio = zona.querySelector("[data-mt-precio]");
    var antes = zona.querySelector("[data-mt-precio-antes]");
    var boton = zona.querySelector("[data-mt-anadir]");
    var textoDisponible = boton ? boton.getAttribute("data-mt-texto") : "";
    var textoAgotado = boton ? boton.getAttribute("data-mt-agotado") : "Agotado";

    function seleccionadas() {
      return Array.prototype.map.call(
        zona.querySelectorAll("[data-mt-opcion]"),
        function (grupo) {
          var act = grupo.querySelector('[aria-pressed="true"]');
          return act ? act.getAttribute("data-mt-valor") : null;
        }
      );
    }

    function formatear(cent) {
      var moneda = datos.getAttribute("data-mt-formato") || "${{amount}}";
      var v = (cent / 100).toLocaleString("es-CO", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return moneda.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }

    function refrescar() {
      var sel = seleccionadas();
      var v = variantes.filter(function (x) {
        return sel.every(function (val, i) { return val === null || x.options[i] === val; });
      })[0];

      if (!v) return;
      if (inputId) inputId.value = v.id;
      if (precio) precio.textContent = formatear(v.price);
      if (antes) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          antes.textContent = formatear(v.compare_at_price);
          antes.hidden = false;
        } else {
          antes.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !v.available;
        var etiqueta = boton.querySelector("[data-mt-etiqueta]");
        if (etiqueta) etiqueta.textContent = v.available ? textoDisponible : textoAgotado;
      }
    }

    zona.querySelectorAll("[data-mt-opcion] .mt-compra__valor").forEach(function (btn) {
      if (!nuevo(btn)) return;
      btn.addEventListener("click", function () {
        var grupo = btn.closest("[data-mt-opcion]");
        grupo.querySelectorAll(".mt-compra__valor").forEach(function (o) {
          o.setAttribute("aria-pressed", o === btn ? "true" : "false");
        });
        refrescar();
      });
    });

    refrescar();
  }

  /* ------------------------------ ir a las opiniones (estrellas del PDP) */
  function initIrOpiniones() {
    document.querySelectorAll("[data-mt-ir-opiniones]").forEach(function (enlace) {
      if (!nuevo(enlace)) return;
      enlace.addEventListener("click", function (ev) {
        var destino = document.querySelector(enlace.getAttribute("href"));
        if (!destino) return;
        ev.preventDefault();
        var y = destino.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: reduce ? "auto" : "smooth" });
      });
    });
  }

  /* ------------------------------------------------- barra de compra fija */
  function initBarra() {
    var barra = document.querySelector("[data-mt-barra]");
    if (!barra || !nuevo(barra)) return;
    barra.hidden = false;

    var desde = parseInt(barra.getAttribute("data-mt-desde"), 10) || 700;
    var pendiente = false;

    function revisar() {
      pendiente = false;
      var abajoDelTodo =
        window.pageYOffset + window.innerHeight >= document.body.scrollHeight - 140;
      var mostrar = window.pageYOffset > desde && !abajoDelTodo;
      barra.classList.toggle("mt-barra--visible", mostrar);
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!pendiente) {
          pendiente = true;
          if (reduce) revisar();
          else requestAnimationFrame(revisar);
        }
      },
      { passive: true }
    );
    window.addEventListener("resize", revisar);
    revisar();
  }

  /* ------------------------------------------------------------ arranque */
  function arrancar() {
    initIrOpiniones();
    initBarra();
    initReveal();
    initHero();
    initParallax();
    initContadores();
    initCalor();
    initModos();
    initCarrusel();
    initFaq();
    initGaleria();
    initCantidad();
    initVariantes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else {
    arrancar();
  }

  /* Reinicia al editar en el editor de Shopify */
  document.addEventListener("shopify:section:load", arrancar);
})();
